import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import {
  ICreateProdutoBody,
  IGetProdutosPaginatedParams,
  IGetProdutosPaginatedResponse,
  IProduto,
  IUpdateProdutoBody
} from './produto.model';

@Injectable({
  providedIn: 'root'
})
export class ProdutoService {
  constructor(private http: HttpClient) {}

  GetProdutos(): Observable<IProduto[]> {
    return this.http.get<IProduto[]>(`${environment.baseURL}Produto/GetProdutos`);
  }

  GetProdutoById(id: number): Observable<IProduto> {
    return this.http.get<IProduto>(
      `${environment.baseURL}Produto/GetProdutoById?id=${id}`
    );
  }

  GetProdutosPaginated(
    params: IGetProdutosPaginatedParams
  ): Observable<IGetProdutosPaginatedResponse> {
    const validParams = Object.fromEntries(
      Object.entries({ PAGE_NUMBER: 1, PAGE_SIZE: 8, ...params }).filter(
        ([_, value]) => value !== '' && value !== null && value !== undefined
      )
    );
    return this.http.get<IGetProdutosPaginatedResponse>(
      `${environment.baseURL}Produto/GetProdutosPaginated`,
      { params: validParams }
    );
  }

  CreateProduto(body: ICreateProdutoBody, guid: string): Observable<IProduto> {
    const headers = new HttpHeaders({ IdempotencyKey: guid });
    return this.http.post<IProduto>(
      `${environment.baseURL}Produto/CreateProduto`,
      body,
      { headers }
    );
  }

  UpdateProduto(id: number, body: IUpdateProdutoBody): Observable<IProduto> {
    return this.http.put<IProduto>(
      `${environment.baseURL}Produto/UpdateProduto?id=${id}`,
      body
    );
  }

  DeleteProduto(id: number): Observable<any> {
    return this.http.delete<any>(
      `${environment.baseURL}Produto/DeleteProduto?id=${id}`
    );
  }
}
